const PHONEME_TYPE = "ssml-phoneme";

export { PHONEME_TYPE };
//# sourceMappingURL=constant.js.map
